var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.isDesktop ? "div" : "c-modal",
    _vm._b(
      {
        tag: "component",
        staticClass: "search-container",
        attrs: { name: "search-container", "is-fullscreen": false },
        on: { close: _vm.$listeners["close"] }
      },
      "component",
      _vm.$attrs,
      false
    ),
    [
      _c("c-modal-mask", {
        attrs: { transparent: "", show: _vm.isMaskOpened },
        on: {
          close: function($event) {
            _vm.openResults = false
          }
        }
      }),
      _vm._v(" "),
      _c(
        "search-field",
        _vm._g(
          {
            staticClass: "field",
            attrs: { term: _vm.term },
            on: {
              input: _vm.updateInput,
              submit: _vm.$listeners["submit-term"],
              close: function($event) {
                _vm.openResults = false
              }
            },
            nativeOn: {
              click: function($event) {
                return _vm.clickInput.apply(null, arguments)
              }
            }
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _vm.isSuggestionsOpened
        ? _c(
            "search-suggestions",
            _vm._b(
              {
                staticClass: "results",
                attrs: { results: _vm.results },
                on: { "click-suggestion": _vm.clickSuggestion }
              },
              "search-suggestions",
              _vm.$attrs,
              false
            )
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9200b3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9200b3c","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/SearchContainer.vue
// module id = 2124
// module chunks = 1610